import styles from './LoaderAnimation.module.scss'

export default function LoaderAnimation ({ darkBackground = false, small = false }) {

  const pixels = (numberOfPixels) => {
    let px = [];
    for (let i = 0; i < numberOfPixels; ++i) {
      px.push(<span className={`${styles.pixel} ${styles[`pixel-${i+1}`]}`} key={`pixel-${i+1}`} />)
    }
    return px;
  }

  return (
    <div className={`${styles.mtLoader} ${darkBackground && styles.negative} ${small && styles.small}`}>
      {pixels(64)}
    </div>
  )
}